import { capitalize } from 'lodash';

// ----------------------------------------------------------------------



export function getFirstCharacter(name) {
  return capitalize(name && name.charAt(0));
}

